import React from 'react';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';

interface QuickFilterProps {
  color?: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
  filters: string[];
  selectedFilters: string[];
  onSelectFilter: (filter: any, selectedTab: any) => void;
  selectedTab: number | string;
}

/** These arrive in `filters` alongside real values but act on the whole set. */
const BULK_ACTIONS = ['Select All', 'Clear All'];

const QuickFilter = ({ color = 'info', filters, onSelectFilter, selectedFilters, selectedTab }: QuickFilterProps) => (
  // Chips wrap instead of scrolling sideways: the row used `overflowY` on a
  // horizontal list, so anything past the edge was simply unreachable.
  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '8px', maxWidth: '100%' }}>
    {filters.map((item) => {
      const isBulkAction = BULK_ACTIONS.includes(item);
      const isSelected = selectedFilters.includes(item);

      return (
        <Chip
          key={item}
          label={item}
          size="small"
          variant={!isBulkAction && isSelected ? 'filled' : 'outlined'}
          color={isBulkAction ? 'default' : color}
          onClick={() => onSelectFilter(item, selectedTab)}
          sx={{
            cursor: 'pointer',
            // Bulk actions are commands, not values, so they never read as an
            // applied filter.
            ...(isBulkAction && { fontWeight: 500, borderStyle: 'dashed' }),
          }}
        />
      );
    })}
  </Box>
);

export default QuickFilter;
export { MultiSelectFilter } from './MultiSelectFilter';
